export default __webpack_public_path__ + "static/media/noOrders.5d4c13c5.svg";